import { QUEUE_NAME, UTM } from 'constants/analytics'
import { sendEvents } from 'services/api/analytics'

import queuevent from './queuevent'
import { RawEvent } from './types'
import { getOriginalTimestamp } from './utils'

const queueCallback = async (rawEvents: RawEvent[]) => {
  const nabuId =
    rawEvents.find((event) => event.payload.traits.nabuId)?.payload.traits.nabuId ?? null
  const email = rawEvents.find((event) => event.payload.traits.email)?.payload.traits.email ?? null
  const tier = rawEvents.find((event) => event.payload.traits.tier)?.payload.traits.tier ?? null
  const parsedTier = tier ? String(tier) : null

  const rawCampaign = sessionStorage.getItem(UTM)
  const campaign = rawCampaign ? JSON.parse(rawCampaign) : {}

  const traits = {
    device: 'WEB',
    email,
    nabu_id: nabuId,
    tier: parsedTier
  }

  const context = {
    campaign,
    traits
  } as const

  const events = rawEvents.map((event) => {
    const name = event.key
    const properties = event.payload.properties ?? {}
    const originalTimestamp = getOriginalTimestamp()
    return {
      nabuId,
      name,
      originalTimestamp,
      properties
    }
  })

  await sendEvents({
    context,
    device: 'WEB',
    events,
    platform: 'EXCHANGE'
  })
}

// figure out how to typesafe this. Probably need to make a new queuing function

const analytics = queuevent<string, any>({
  queueCallback,
  queueName: QUEUE_NAME
})

export default analytics
